import type { CSSProperties } from 'react';
import type { CommonSpacerZone } from '@/types/homepage';
import styles from './CommonSpacer.module.css';

function resolveHeights(zone: CommonSpacerZone) {
  const mobile = zone.heightMobile || '0px';

  if (zone.__component === 'common.spacer-full') {
    return {
      mobile,
      tablet: zone.heightTablet || mobile,
      desktop: zone.heightiDesktop || zone.heightTablet || mobile,
    };
  }

  return {
    mobile,
    tablet: zone.heightTab || mobile,
    desktop: zone.heightDesktop || zone.heightTab || mobile,
  };
}

interface CommonSpacerProps {
  zone: CommonSpacerZone;
}

export default function CommonSpacer({ zone }: CommonSpacerProps) {
  const heights = resolveHeights(zone);
  let variantClass: string;
  if (zone.__component === 'common.spacer-top') {
    variantClass = styles.top;
  } else if (zone.__component === 'common.spacer-bottom') {
    variantClass = styles.bottom;
  } else {
    variantClass = styles.full;
  }

  const style = {
    '--spacer-h-mobile': heights.mobile,
    '--spacer-h-tablet': heights.tablet,
    '--spacer-h-desktop': heights.desktop,
    '--spacer-bg': zone.spacerBg || 'transparent',
  } as CSSProperties;

  return (
    <div
      aria-hidden
      data-viewport-blur-target
      className={`${styles.spacer} ${variantClass}`}
      style={style}
      suppressHydrationWarning
    />
  );
}
